import StudentProgressService from "../../services/StudentProgress";
import { StudentProgress } from "../../types";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

import { QUERY_KEY } from "./useListStudentProgress";

export const makeQueryKey = (id?: StudentProgress["id"]) => [QUERY_KEY, id];

function useFetchStudentProgress(id?: StudentProgress["id"]) {
  const key = makeQueryKey(id);

  return useAuthorizedQuery(
    key,
    () => {
      if (id) {
        return StudentProgressService.fetchStudentProgressions(id);
      }

      throw new Error("student progress id is required");
    },
    { enabled: !!id }
  );
}

export default useFetchStudentProgress;
